var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenHorizontalStrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67.69 16.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Emerald_2);}.cls-15,.cls-2{opacity:0.35;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#Bronze_2);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13,.cls-25,.cls-31{opacity:0.5;}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#Emerald_2-2);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:url(#linear-gradient-13);}.cls-18{fill:url(#Bronze_2-2);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-20);}.cls-26{fill:url(#Emerald_2-3);}.cls-27{fill:#95c796;}.cls-28{fill:url(#Bronze_2-3);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Emerald_2",
    x1: -13,
    y1: 28.6,
    x2: 3.01,
    y2: 28.6,
    gradientTransform: "matrix(0, 1, 1, 0, -17.88, 13.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#048246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#10894b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#249452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#40a35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#63b769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#78c271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#64b76a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#40a35d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#249452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#10894b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#048246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008045"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.39,
    y1: 41.67,
    x2: 2.39,
    y2: 19.22,
    gradientTransform: "matrix(0, 1, 1, 0, -17.88, 13.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#143c1d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003c10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -12.43,
    y1: 33.17,
    x2: 2.79,
    y2: 17.95,
    gradientTransform: "matrix(0, 1, 1, 0, -17.88, 13.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#add7a7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#add7a7",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#add7a7",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#add7a7",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#add7a7",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#add7a7",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#add7a7",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#add7a7",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#add7a7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#add7a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -12.35,
    y1: 43.44,
    x2: -12.35,
    y2: 33.48,
    gradientTransform: "matrix(0, 1, 1, 0, -17.88, 13.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#add7a7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#add7a7",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#add7a7",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#add7a7",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#add7a7",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#add7a7",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#add7a7",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#add7a7",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#add7a7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#add7a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2",
    x1: 6.37,
    y1: 7.97,
    x2: 21.44,
    y2: 7.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6b4c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#a48955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e4d3b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#957858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#957858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#804f2e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -10.4,
    y1: 36.83,
    x2: -9.37,
    y2: 36.83,
    gradientTransform: "matrix(0, 1, 1, 0, -17.88, 13.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#536e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2d7e6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#918456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a1b37b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#487774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 689.69,
    y1: 276.16,
    x2: 690.49,
    y2: 276.16,
    gradientTransform: "matrix(-0.72, -0.69, -0.69, 0.72, 701.64, 284.77)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.75,
    y1: 31.79,
    x2: 0.43,
    y2: 31.79,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 558.88,
    y1: 875.45,
    x2: 558.88,
    y2: 874.11,
    gradientTransform: "translate(574.11 886.34) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 27.03,
    y1: 5.98,
    x2: 27.03,
    y2: 4.64,
    gradientTransform: "translate(-7.77 -0.93)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -4.03,
    y1: -19.05,
    x2: -5.15,
    y2: -20.17,
    gradientTransform: "matrix(0, 1, 1, 0, 33.1, 13.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 11.91,
    y1: 13.41,
    x2: 11.91,
    y2: 14.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eada91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eada91",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Emerald_2-2",
    x1: -13.01,
    y1: 594.35,
    x2: 3,
    y2: 594.35,
    gradientTransform: "translate(651.32 13) rotate(90)",
    xlinkHref: "#Emerald_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 46.25,
    y1: 15.41,
    x2: 67.63,
    y2: 15.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -12.43,
    y1: 598.91,
    x2: 2.79,
    y2: 583.69,
    gradientTransform: "translate(651.32 13) rotate(90)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -12.32,
    y1: 609.48,
    x2: -12.32,
    y2: 598.98,
    gradientTransform: "translate(651.32 13) rotate(90)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-2",
    x1: 46.25,
    y1: 7.97,
    x2: 61.32,
    y2: 7.97,
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -10.46,
    y1: 602.58,
    x2: -9.27,
    y2: 602.58,
    gradientTransform: "translate(651.32 13) rotate(90)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 280.34,
    y1: -114.36,
    x2: 281.15,
    y2: -114.36,
    gradientTransform: "translate(-68.2 284.77) rotate(-43.65)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.73,
    y1: 597.53,
    x2: 0.43,
    y2: 597.53,
    gradientTransform: "translate(651.32 13) rotate(90)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -57.87,
    y1: 875.5,
    x2: -57.87,
    y2: 874.12,
    gradientTransform: "matrix(1, 0, 0, -1, 110.34, 886.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 643.72,
    y1: 6.04,
    x2: 643.72,
    y2: 4.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 692.16, -0.97)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -3.9,
    y1: 597.77,
    x2: -5.12,
    y2: 596.55,
    gradientTransform: "translate(651.32 13) rotate(90)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2116.59,
    y1: 13.41,
    x2: 2116.59,
    y2: 14.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 2172.36, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Emerald_2-3",
    x1: 33.75,
    y1: 0,
    x2: 33.75,
    y2: 16.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Emerald_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-3",
    x1: 46.42,
    y1: 7.97,
    x2: 21.08,
    y2: 7.97,
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.78,
    y1: 51.63,
    x2: 0.41,
    y2: 51.63,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -10.44,
    y1: 51.61,
    x2: -9.34,
    y2: 51.61,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 33.75,
    y1: 13.41,
    x2: 33.75,
    y2: 14.81,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 41.52,
    y1: 5.98,
    x2: 41.52,
    y2: 4.64,
    gradientTransform: "translate(-7.77 -0.93)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 41.49,
    y1: 608.79,
    x2: 41.49,
    y2: 607.42,
    gradientTransform: "matrix(1, 0, 0, -1, -7.74, 619.68)",
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left_Frame",
    "data-name": "Left Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M21.44,0H14.72a.43.43,0,0,0-.32.14L.12,15.26A.45.45,0,0,0,.45,16h21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M.74,16a1.2,1.2,0,0,1-.49,0,1,1,0,0,1-.18-.19l2.32-1H21.44V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M2.39,14.81,15.44,1.35,14.72,0s-.2,0-.26.07c-.27.31-.61.65-.61.65L.67,14.68a4.25,4.25,0,0,0-.6.66.39.39,0,0,0,0,.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "15.44 1.35 14.72 0 21.44 0 21.44 1.35 15.44 1.35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "21.44 2.52 16.47 2.54 6.37 13.41 21.44 13.41 21.44 2.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "21.44 3.71 17.07 3.71 16.47 2.54 21.44 2.52 21.44 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "6.37 13.41 16.47 2.53 17.07 3.71 9.02 12.23 6.37 13.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "21.44 12.23 9.02 12.23 6.37 13.41 21.44 13.41 21.44 12.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "21.44 12.23 9.02 12.23 17.07 3.72 21.44 3.71 21.44 12.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "12.13 10.89 21.44 10.89 21.44 12.23 9.02 12.23 12.13 10.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "21.44 5.05 17.86 5.05 17.07 3.71 21.44 3.71 21.44 5.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "9.02 12.23 17.07 3.71 17.86 5.05 12.13 10.89 9.02 12.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2.39 14.81 6.42 13.41 21.43 13.41 21.44 14.81 2.39 14.81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right_Frame",
    "data-name": "Right Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-14",
    d: "M46.25,0H53a.45.45,0,0,1,.33.14L67.57,15.26a.44.44,0,0,1-.32.75h-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-15",
    d: "M67,16a1.21,1.21,0,0,0,.5,0,1.42,1.42,0,0,0,.18-.19l-2.32-1H46.25V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-16",
    d: "M65.31,14.81,52.26,1.34,53,0s.21,0,.26.07c.27.31.61.65.61.65L67,14.68a4.25,4.25,0,0,1,.6.66.39.39,0,0,1,0,.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-17",
    points: "52.26 1.34 52.97 0 46.25 0 46.25 1.34 52.26 1.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-18",
    points: "46.25 2.52 51.23 2.54 61.32 13.41 46.25 13.41 46.25 2.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-19",
    points: "46.25 2.52 51.23 2.54 50.63 3.74 46.25 3.74 46.25 2.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-20",
    points: "61.32 13.41 51.23 2.53 50.62 3.73 58.67 12.26 61.32 13.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-21",
    points: "46.25 12.26 58.67 12.26 61.32 13.41 46.25 13.41 46.25 12.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "46.25 12.26 58.67 12.26 50.63 3.75 46.25 3.74 46.25 12.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-22",
    points: "55.34 10.9 46.25 10.88 46.25 12.26 58.67 12.26 55.34 10.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-23",
    points: "46.25 5.08 49.84 5.08 50.63 3.74 46.25 3.74 46.25 5.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "58.67 12.26 50.63 3.74 49.84 5.08 55.34 10.9 58.67 12.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "65.3 14.81 61.27 13.41 46.26 13.41 46.25 14.81 65.3 14.81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 21.08,
    width: 25.34,
    height: 16.01
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-27",
    x: 33.08,
    y: -11.99,
    width: 1.34,
    height: 25.33,
    transform: "translate(34.43 -33.08) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M21.09,13.41H46.42m0-10.89H21.08M46.42,13.41V12.26L29,12.23H21.08v1.18M46.42,3.74V2.52H21.08V3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-29",
    points: "46.42 13.41 21.08 13.41 21.08 12.23 46.42 12.26 46.42 13.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-30",
    points: "46.42 3.74 21.08 3.71 21.08 2.52 46.42 2.52 46.42 3.74"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "21.09 14.81 21.08 13.41 46.42 13.41 46.42 14.81 21.09 14.81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "46.42 12.26 46.42 3.74 21.08 3.71 21.08 12.23 46.42 12.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-32",
    points: "46.42 5.05 21.08 5.05 21.08 3.71 46.42 3.74 46.42 5.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-33",
    points: "46.42 10.88 21.08 10.88 21.08 12.23 46.42 12.26 46.42 10.88"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHorizontalStrip);
export default __webpack_public_path__ + "static/media/greenHorizontalStrip.1d2a18f4aa498b07260a5fcd025bd802.svg";
export { ForwardRef as ReactComponent };